import React from "react";
import BerandaAffiliateSummary from "./berandaCard";

const BerandaAffiliate = () => {
  return (
    <div className="p-3">
      <div className="flex justify-start font-bold text-2xl">Beranda</div>
      <div className="mt-3">
        <BerandaAffiliateSummary />
      </div>
    </div>
  );
};

export default BerandaAffiliate;
